import type { Cancellable } from '@cli-types/core-engine/commands.js'
import { CANCELLED } from '@cli-constants/commands.js'

export function cancelled<T>(value: Cancellable<T>): value is typeof CANCELLED {
  return value === CANCELLED
}
